import { LanguagesEnum } from '@/api/enums';
import hardcodedTranslations from '@/locales/hardcodedTranslations';
import { FlexContainer } from '@/ui/styled-ui';
import { ProgressBar } from 'primereact/progressbar';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const StyledProgressHeader = styled(FlexContainer)`
  width: 100%;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: var(--big-padding);
  gap: var(--default-padding);

  .progress-text {
    min-width: max-content;
    font-size: var(--xsmall-font-size);
    line-height: var(--xsmall-line-height);
  }
`;

const StyledProgressBar = styled(ProgressBar)`
  width: 100%;
  height: 4px;
  background: var(--gray-dark);

  .p-progressbar-value {
    background: var(--red-main);
  }
`;

export type ProgressHeaderProps = {
  currentIndex: number;
  totalCount: number;
  className?: string;
  translationKey?: string;
  attemptLanguage?: LanguagesEnum;
  type?: 'quiz' | 'slide' | undefined;
};

export const ProgressHeader: React.FC<ProgressHeaderProps> = ({
  currentIndex,
  totalCount,
  className,
  translationKey = 'quiz.progress.text',
  attemptLanguage,
  type,
}) => {
  const { t } = useTranslation();

  return (
    <StyledProgressHeader className={className}>
      <div className="progress-text">
        {attemptLanguage && type
          ? hardcodedTranslations[type].currentOutOfTotal[attemptLanguage](
              currentIndex + 1,
              totalCount || 0,
            )
          : t(translationKey, {
              currentQuestionIndex: currentIndex + 1,
              allQuestionsCount: totalCount || 0,
            })}
      </div>
      <StyledProgressBar
        aria-hidden={true}
        value={(100 * (currentIndex + 1)) / (totalCount || 1)}
        showValue={false}
      />
    </StyledProgressHeader>
  );
};
